module.exports = __webpack_public_path__ + "static/media/icon-not-checked.a8cb209e.svg";